import ActionTypes from "../../../../constants/ActionTypes";
import { ISendVerificationSms, ISendVerificationCode, IVerificationSmsState, ISendVerificationSmsSuccess, ISendVerificationCodeSuccess } from "./types";


export const setSmsFlagsFromOrder = (data: IVerificationSmsState): ISendVerificationSms => ({
  type: ActionTypes.ORDER.SET_SMS_FLAGS,
  payload: data,
});

export const sendVerificationSms = (data: any): ISendVerificationSms => ({
  type: ActionTypes.ORDER.SEND_VERIFICATION_SMS,
  payload: data,
});

export const sendVerificationSmsSuccess = (data: boolean): ISendVerificationSmsSuccess => ({
  type: ActionTypes.ORDER.SEND_VERIFICATION_SMS_SUCCESS,
  payload: data,
});

export const sendVerificationCode = (data: any): ISendVerificationCode => ({
  type: ActionTypes.ORDER.SEND_VERIFICATION_CODE,
  payload: data
});

export const sendVerificationCodeSuccess = (data: boolean): ISendVerificationCodeSuccess => ({
  type: ActionTypes.ORDER.SEND_VERIFICATION_CODE_SUCCESS,
  payload: data,
});
